import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, AuthTokens } from './types';
import { loadState } from '@shared/lib/LocalStorage/localStorage';


const initialState: AuthState ={
  tokens: loadState(),
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<AuthTokens>) => {
      state.tokens = action.payload;
      localStorage.setItem('auth_tokens', JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.tokens = null;
      localStorage.removeItem('auth_tokens');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;